import { render, staticRenderFns } from "./donut-basic.vue?vue&type=template&id=feb00028&"
import script from "./donut-basic.vue?vue&type=script&lang=js&"
export * from "./donut-basic.vue?vue&type=script&lang=js&"
import style0 from "./donut-basic.vue?vue&type=style&index=0&id=feb00028&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports